import { classicProjectFieldsEntryPoint } from '@jira/project-settings__classic-project-fields/src/classicProjectFieldsEntryPoint.entrypoint.tsx';
import { classicProjectSettingsSoftwareFieldsRoute } from '@jira/router-routes__classic-project-settings-fields-routes/src/classicProjectSettingsSoftwareFieldsRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getSettingsNavigationResources } from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/product-routes/common/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';

// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: classicProjectFieldsEntryPoint,
});
export const classicProjectSettingsSoftwareFieldsRouteEntry: Route = createEntry(
	classicProjectSettingsSoftwareFieldsRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.fields.jsw-cmp',
		layout: softwareProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		canTransitionIn: () => !fg('mc-nfa-soft-rollback'),
		resources: [...getSettingsNavigationResources()],
		entryPoint: () => {
			if (fg('mc-nfa-soft-rollback')) {
				return undefined;
			}
			return pageEntryPoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		meta: {
			reporting: {
				packageName: 'jiraClassicProjectSettingsProjectFields',
				id: 'project-settings.fields.jsw-cmp',
				teamName: 'Yamato',
			},
		},
	}),
);
